interface SizedBoxProps {
    height?: number;
    width?: number;
}

export function SizedBox({ height, width }: SizedBoxProps) {
    return (
        <div
            style={{
                height: height ?? "auto",
                width: width ?? "auto",
            }}
        />
    );
}